import React from "react";
import CompanyPage from "./CompanyPage";
import ContactsPage from "./ContactsPage";
import NewsPage from "./NewsPage";
import ProductionPage from "./ProductionPage";

export default function MainPage() {
    return (
        <div>
            <CompanyPage></CompanyPage>
            <NewsPage showInMainPage={true}/>
            <ProductionPage showInMainPage={true}></ProductionPage>
            <ContactsPage></ContactsPage>
        </div >
    );
}